<p class="macmillan-book-title" transloco="macMillan.dialog.header"
>Choose your book.</p>
<p class="macmillan-book-description" transloco="macMillan.dialog.description"
>
  Please select the cover of the book you got the bulb promo code out of.
</p>
<aero-image-radio-group>
  <aero-image-radio-button
    (click)="imageSelected()"
    [(selectedImageId)]="selectedBook"
    [value]="'NEXT_STATION_2'"
    [imageSrc]="'resources/images/next_station_2.svg' ">
  </aero-image-radio-button>
  <aero-image-radio-button
    (click)="imageSelected()"
    [(selectedImageId)]="selectedBook"
    [value]="'NEXT_STATION_3'"
    [imageSrc]="'resources/images/next_station_3.svg' ">
  </aero-image-radio-button>
  <aero-image-radio-button
    (click)="imageSelected()"
    [(selectedImageId)]="selectedBook"
    [value]="'NEXT_STATION_4'"
    [imageSrc]="'resources/images/next_station_4.svg' ">
  </aero-image-radio-button>
</aero-image-radio-group>
<aero-button [disabled]="!bookSelected"
       (onClick)="continue()"
       labelCode="button_continue">
</aero-button>
